import _ from 'lodash';
import { isMac } from './utils';

const formatModifier = (key) =>
  ({
    shift: 'Shift',
    alt: isMac() ? '⌥' : 'Alt',
    ctrl: 'Control',
    meta: isMac() ? 'Command' : 'Windows',
    mod: isMac() ? 'Command' : 'Control',
  }[key]);

export const formatHotkeyExpression = (
  keys, // string
  combinationKey = '+',
) => {
  // Special case for question mark:
  if (keys.toLowerCase() === `shift${combinationKey}?`) return '?';

  // Special case for backslash:
  // eslint-disable-next-line no-param-reassign
  keys = keys.replace('backslash', '\\');

  if (keys.includes(',')) {
    throw new Error(
      'formatHotkeyExpression does not support formatting multiple shortcuts.',
    );
  }

  return keys
    .split(combinationKey)
    .map((key) => formatModifier(key) ?? _.capitalize(key))
    .join('-');
};

export const getShortcutDescription = (shortcut) => {
  // Handle the 'a, b' syntax:
  if (shortcut.includes(',')) {
    // eslint-disable-next-line no-param-reassign
    shortcut = shortcut.split(',').map((s) => s.trim());
  }

  // Handle multiple shortcuts:
  if (Array.isArray(shortcut)) {
    return `Shortcuts: ${shortcut
      .map((keys) => formatHotkeyExpression(keys))
      .join(', ')}`;
  }

  // Single shortcut:
  return `Shortcut: ${formatHotkeyExpression(shortcut)}`;
};
